import { Injectable } from '@angular/core';
import { ActiveCartService } from '@cart/data-access';
import { isCheckoutRoute } from '@checkout/utils';
import { EnvironmentService, RunEffectsOnSemanticRouteService } from '@core/feature';
import { Actions, createEffect, EffectNotification, OnRunEffects } from '@ngrx/effects';
import { EMPTY, iif, Observable } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';
import { CustomCheckoutService } from '../services';

@Injectable()
export class CheckoutReInitEffects implements OnRunEffects {
  // Каждый раз при заходе на страницу чекаута обновляем данные о заказе, так как возможно корзина обновилась
  checkoutInit$: Observable<void> = createEffect(
    () =>
      this.actions$.pipe(
        take(1),
        tap(() => {
          this.activeCartService
            .getActive()
            .pipe(take(1))
            .subscribe((cart) => {
              this.customCheckoutService.updateCustomerConsignment(cart);
            });
        }),
        switchMap(() => EMPTY),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private customCheckoutService: CustomCheckoutService,
    private activeCartService: ActiveCartService,
    private environmentService: EnvironmentService,
    private runEffectsOnSemanticRouteService: RunEffectsOnSemanticRouteService,
  ) {}

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>): Observable<EffectNotification> {
    return iif(
      () => this.environmentService.isPlatformBrowser,
      this.runEffectsOnSemanticRouteService.ngrxOnRunEffectsOnSemanticRoute(isCheckoutRoute)(resolvedEffects$),
      EMPTY,
    );
  }
}
